import { render, staticRenderFns } from "./XInputGroupStatisticTemplate.vue?vue&type=template&id=16d69b4c"
import script from "./XInputGroupStatisticTemplate.vue?vue&type=script&lang=js"
export * from "./XInputGroupStatisticTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports